import React, { useState } from 'react'
import { FUNCTIONS } from '../consts/functions'
import { FUNCTIONS2 } from '../consts/functions'
import Button from './Button'
import FunctionsStyle from '../styles/FunctionsStyle'

const Functions = ({ functionsRef }) => {
  const [isExpanded, setExpanded] = useState(true)
  const handleExpanded = () => {
    setExpanded(!isExpanded)
  }
  const textPanels = FUNCTIONS,
    textPanels2 = FUNCTIONS2
  const content = arr =>
    arr.map(item => {
      return (
        <div key={item.key}>
          <h4>{item.title}</h4>
          <p>
            {item.description.split('\n').map((el, i) => (
              <span key={item.key + i}>
                {el}
                <br />
              </span>
            ))}
          </p>
        </div>
      )
    })
  return (
    <FunctionsStyle isExpanded={isExpanded} ref={functionsRef}>
      <div className="container">
        <ul className="nav-flex">
          <li onClick={handleExpanded} className={isExpanded ? 'active' : ''}>
            <h3>Dostępne e-sprawozdania</h3>
          </li>
          <li onClick={handleExpanded} className={!isExpanded ? 'active' : ''}>
            <h3>Funkcje programu</h3>
          </li>
        </ul>
        {isExpanded ? content(textPanels2) : content(textPanels)}
        <Button link="/app/?path=account" title="wypróbuj za darmo" />
      </div>
      <div className="container-xs">
        <h3>Funkcje programu</h3>
        {content(textPanels)}
        <h3>Dostępne e-sprawozdania</h3>
        {content(textPanels2)}
        <Button link="/app/?path=account" title="wypróbuj za darmo" />
      </div>
    </FunctionsStyle>
  )
}

export default Functions
